function addToCardUpsell(data, el) {
    el.disabled = true;
    let items = Alpine.raw(data.items);
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: items
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Oops! Something went wrong - ${response.status} ${response.statusText}`);
        }
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        window.dispatchEvent(new Event("cart-updated"));
        el.disabled = false;
      });
  }